
































import { Component, Prop, Vue } from "vue-property-decorator";

/**
 * Earthquake-epicenter mark: a centre dot with concentric radiating rings. It was easier to create a custom SVG rather
 * than introducing a new dependency. v4-pinned mdi icon font has no epicenter glyph. Colour comes
 * from `currentColor`, so the consumer sets it via CSS `color`; `size` is the rendered px
 * (default 16, matching the dashboard's small mdi tab icons).
 */
@Component
export default class EpicenterIcon extends Vue {
    @Prop({ default: 16 }) size!: number;
}
